export const KEY_CATALOG_PAGE_STORAGE_KEY = "vocabularium_key_catalog_page";

export function readKeyCatalogPage(pageCount) {
  if (!Number.isFinite(pageCount) || pageCount < 1) return 0;

  try {
    const raw = localStorage.getItem(KEY_CATALOG_PAGE_STORAGE_KEY);
    if (raw == null) return 0;
    const page = parseInt(raw, 10);
    if (!Number.isFinite(page) || page < 0 || page >= pageCount) return 0;
    return page;
  } catch {
    return 0;
  }
}

export function writeKeyCatalogPage(pageIndex) {
  try {
    localStorage.setItem(KEY_CATALOG_PAGE_STORAGE_KEY, String(pageIndex));
  } catch {
    // ignore quota / privacy mode errors
  }
}
